import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { EmployeeService } from 'src/app/shared/services/employee.service';
import { DelegationService } from 'src/app/shared/services/delegation.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Advance } from 'src/app/shared/models/advance.model';
import { tap, switchMap, map } from 'rxjs/operators';
import { Delegation } from 'src/app/shared/models/delegation.model';
import { of } from 'rxjs';
import { HttpResponse } from 'src/app/shared/models/http-response.model';

@Component({
  selector: 'app-delegation-add',
  templateUrl: './delegation-add.component.html'
})
export class DelegationAddComponent implements OnInit {

  employees$;
  advances$;
  newDelegationFormGroup;

  selectsLoading = {
    employee: true,
    advance: true,

  };

  constructor(
    private fb: FormBuilder,
    private employeeService: EmployeeService,
    private delegationService: DelegationService,
    private toastrService: ToastrService,
    private router: Router
  ) { }

  ngOnInit() {
    this.createFormGroup();
    this.employees$ = this.employeeService.activeEmployees$.pipe(
      tap(v => this.selectsLoading.employee = false)
    );
    this.setupChangeEmployeeAction();
  }

  createFormGroup() {
    this.newDelegationFormGroup = this.fb.group({
      delegationNumber: [null, [Validators.required]],
      employee: [null, [Validators.required]],
      grossValue: [null, [Validators.required]],
      advance: [null, [Validators.required]],
    });
  }

  setupChangeEmployeeAction() {
    this.selectsLoading.advance = true;
    this.advances$ = this.newDelegationFormGroup.get('employee').valueChanges.pipe(
      tap(v => this.newDelegationFormGroup.get('advance').setValue(null)),
      switchMap((employeeId: number) => {
        // this.newDelegationFormGroup.get('advance').enable();
        if (employeeId && employeeId !== -1) {
          return this.employeeService.fetchAdvances(employeeId).pipe(
            map(v => v.filter(e => e.id !== -1)),
            );
        } else {
          return of([]);
        }
      }),
      tap((v: Advance[]) => {
        this.selectsLoading.advance = true;
        const advanceId = v.length === 1 ? v[0].id : null;
        this.newDelegationFormGroup.get('advance').setValue(advanceId);
      }),
      tap(_ => this.newDelegationFormGroup.get('advance').reset())
    );
  }

  submit() {
    const transformedForm = {
      ...this.newDelegationFormGroup.value,
      employee: parseInt(this.newDelegationFormGroup.get('employee').value, 10),
      advance: parseInt(this.newDelegationFormGroup.get('advance').value, 10)
    };
    const delegation = Delegation.adapt(transformedForm);
    this.delegationService.createDelegation(delegation).subscribe((response: HttpResponse) => {
      this.router.navigate([`dashboard`]);
      if(response.status == 200) {
        this.toastrService.success('Poprawnie utworzono delegacje.');
      } else {
        this.toastrService.error('Nie udało się utworzyć delegacji.');
      }
    });
  }
}
